"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MuiFormHelperText = void 0;
var typography_1 = require("../../../theme/global/typography");
exports.MuiFormHelperText = {
    root: __assign(__assign({}, typography_1.typography.body2), { marginTop: 0, paddingLeft: 0, '&[class*="Mui-error"]': {
            display: 'flex',
            alignItems: 'center',
        } }),
    contained: {
        paddingTop: 8,
        marginRight: 0,
        marginLeft: 12,
    },
};
